export const siteInfo = {
  name: '诱惑吃瓜',
  nameEn: 'YUHUO CHIGUA',
  slogan: '专注颜值与视觉盛宴',
  tagline: '美照生图、红毯造型、明星同框高光时刻全收录',
  description:
    '诱惑吃瓜专注颜值与视觉盛宴，美照生图、红毯造型、明星同框高光时刻全收录。想看谁的生图最能打、哪对同框最有火花，高清美图与红毯名场面一次看个够。',
  email: 'hello@youhuochigua.com',
  cooperation: 'pr@youhuochigua.com',
  since: 2019,
  stats: [
    { label: '收录高清图集', value: '12,000+' },
    { label: '红毯名场面', value: '3,600+' },
    { label: '日均更新', value: '40 组' },
    { label: '读者聚集地', value: '86 万' },
  ],
};

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  intro: string;
  image: string;
  alt: string;
}

export const categories: CategoryItem[] = [
  {
    slug: 'beauty',
    name: '颜值美照',
    icon: 'ri-camera-lens-line',
    intro: '棚拍大片、品牌写真与自然光实拍，记录镜头前最耐看的那一面。',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20glamour%20studio%20set%20with%20soft%20warm%20beauty%20lighting%2C%20elegant%20cream%20backdrop%2C%20silk%20fabric%20and%20cosmetic%20props%2C%20warm%20golden%20tone%2C%20luxury%20magazine%20aesthetic%2C%20no%20people%2C%20high%20detail&width=900&height=675&seq=gossip-cat-beauty-01&orientation=landscape',
    alt: '温馨暖色调棚拍布光与丝缎道具，呈现颜值美照栏目质感',
  },
  {
    slug: 'redcarpet',
    name: '生图红毯',
    icon: 'ri-vip-diamond-line',
    intro: '未经修饰的红毯生图直出，灯光、走位与真实状态一次看全。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20empty%20red%20carpet%20staircase%20with%20golden%20light%20beams%2C%20crimson%20velvet%20drapes%2C%20silver%20rope%20barriers%2C%20theatrical%20haze%2C%20warm%20crimson%20and%20gold%20palette%2C%20editorial%20event%20photography%2C%20no%20people&width=900&height=675&seq=gossip-cat-redcarpet-01&orientation=landscape',
    alt: '金色光束笼罩的红色地毯台阶，呈现生图红毯栏目氛围',
  },
  {
    slug: 'group',
    name: '高光同框',
    icon: 'ri-group-2-line',
    intro: '双人同框、群像站位与后台互动，捕捉最有火花的那几秒。',
    image:
      'https://readdy.ai/api/search-image?query=Two%20elegant%20velvet%20chairs%20facing%20each%20other%20on%20a%20stage%20under%20warm%20golden%20spotlights%2C%20dark%20crimson%20curtain%20backdrop%2C%20soft%20haze%2C%20symmetrical%20editorial%20composition%2C%20luxury%20award%20ceremony%20mood%2C%20no%20people&width=900&height=675&seq=gossip-cat-group-01&orientation=landscape',
    alt: '暖金聚光灯下对称摆放的两把丝绒椅，象征高光同框栏目',
  },
  {
    slug: 'style',
    name: '造型解析',
    icon: 'ri-shirt-line',
    intro: '礼服剪裁、配色逻辑与珠宝搭配，拆解每一次出场背后的造型功课。',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20a%20champagne%20satin%20evening%20gown%20fabric%2C%20delicate%20gold%20jewelry%2C%20high%20heels%20and%20silk%20gloves%20arranged%20on%20a%20marble%20surface%2C%20warm%20amber%20lighting%2C%20fashion%20magazine%20styling%20editorial%2C%20no%20people&width=900&height=675&seq=gossip-cat-style-01&orientation=landscape',
    alt: '大理石台面上的香槟色缎面礼服与金饰平铺造型图',
  },
];

export interface ArticleSection {
  heading?: string;
  paragraphs: string[];
  quote?: string;
}

export interface ArticleItem {
  id: string;
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  views: string;
  excerpt: string;
  image: string;
  alt: string;
  tags: string[];
  related: string[];
  sections: ArticleSection[];
}

export const articles: ArticleItem[] = [
  {
    id: 'a01',
    slug: 'morning-light-portrait-guide',
    title: '清晨自然光下的一组生图，为什么越看越耐看',
    category: 'beauty',
    categoryName: '颜值美照',
    author: '顾晚晴',
    date: '2026-09-06',
    readTime: '6 分钟',
    views: '18.4 万',
    excerpt:
      '没有打光板、没有反光板，只有早上七点的窗边柔光。这组被反复转发的生图，赢在了最朴素的三个细节上。',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20morning%20window%20light%20falling%20across%20a%20minimal%20cream%20studio%20corner%20with%20flowing%20linen%20curtains%20and%20a%20single%20elegant%20vase%2C%20warm%20golden%20highlights%2C%20gentle%20shadows%2C%20editorial%20beauty%20photography%20aesthetic%2C%20no%20people&width=1200&height=900&seq=gossip-art-morning-light-01&orientation=landscape',
    alt: '清晨柔光穿过米色窗帘落在简约影棚角落的画面',
    tags: ['自然光', '棚拍', '生图质感'],
    related: ['stage-lighting-skin-tone', 'champagne-gown-styling', 'backstage-group-portrait'],
    sections: [
      {
        paragraphs: [
          '这组照片最早出现在一个小众摄影账号里，转发量在两天内翻了三倍。很多人第一反应是"这不像是随手拍的"，但翻出拍摄花絮才发现，现场确实只有一扇窗、一块米色背景布和一台相机。',
          '真正让画面耐看的，是光的方向。早上七点到八点之间，阳光斜切进房间，形成一条柔和的侧逆光轮廓，面部没有明显阴影，皮肤的质感被完整保留下来。',
        ],
      },
      {
        heading: '为什么柔光比补光更讨喜',
        paragraphs: [
          '我们习惯了把面部打得很亮，但过度补光会抹平结构，让五官失去层次。清晨的散射光强度低、方向柔，恰好能在鼻梁、下颌和锁骨处留下细微的明暗过渡，这种过渡在生图里尤其珍贵。',
          '另一个常被忽略的细节是背景。米色和浅木色的背景不会与肤色抢视线，视线自然落回人物本身，这也是整组照片显得干净的原因。',
        ],
      },
      {
        heading: '普通人复刻的三个关键点',
        paragraphs: [
          '第一，选对时间。下午三四点的窗边光同样柔和，但色温偏暖，拍出来会更有氛围。第二，让背景保持单一色块，不要出现花纹和杂物。第三，别急着美颜，保留一点皮肤纹理，反而更耐看。',
        ],
        quote: '好生图不是没有瑕疵，而是把所有杂质都降到了最低，只留下光。',
      },
    ],
  },
  {
    id: 'a02',
    slug: 'stage-lighting-skin-tone',
    title: '舞台光下依旧不发灰，肤色还原到底靠什么',
    category: 'beauty',
    categoryName: '颜值美照',
    author: '沈斯年',
    date: '2026-09-03',
    readTime: '5 分钟',
    views: '12.7 万',
    excerpt:
      '同样是强烈的舞台追光，有人拍出来满脸油光，有人却能保持通透。差别往往不在设备，而在前期准备与后期思路。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20stage%20lighting%20setup%20with%20warm%20amber%20spotlight%20beams%20cutting%20through%20soft%20haze%2C%20dark%20crimson%20backdrop%2C%20golden%20rim%20light%20glow%2C%20dramatic%20theatrical%20atmosphere%2C%20editorial%20concert%20photography%20mood%2C%20no%20people&width=1200&height=900&seq=gossip-art-stage-light-01&orientation=landscape',
    alt: '暖琥珀色追光穿透薄雾打在深红舞台背景上的画面',
    tags: ['舞台光', '肤色还原', '通透感'],
    related: ['morning-light-portrait-guide', 'red-carpet-raw-shots', 'gown-colour-logic'],
    sections: [
      {
        paragraphs: [
          '舞台光的问题从来不是不够亮，而是太杂。主光、面光、侧光、地面反射光层层叠加，任何一层偏色，最后都会呈现在肤色上。',
          '所以真正决定成片质量的，是拍摄前对现场色温的判断。暖白光和冷白光混在一起时，皮肤最容易发灰，这时候需要把白平衡锁死，而不是交给自动模式。',
        ],
      },
      {
        heading: '前期能做对的三件事',
        paragraphs: [
          '控制妆面油光比什么都重要。舞台灯温度高，额头和鼻翼的反光会被放大，用一点哑光散粉就能明显改善。其次是服装颜色，深色礼服容易吸光，浅色礼服容易过曝，中间调最稳。',
          '最后是走位。有经验的人会主动停在光斑边缘而不是正中心，让面部一半亮一半过渡，这种光比在舞台生图里非常讨喜。',
        ],
      },
      {
        heading: '后期别急着提亮',
        paragraphs: [
          '很多人拿到偏灰的原片，第一反应是拉高曝光。正确做法反而是先压低高光、找回细节，再整体增加一点对比，最后单独调整肤色的饱和度。顺序反了，皮肤就会变得又脏又糊。',
        ],
        quote: '肤色不是调出来的，是前期就没让它变脏。',
      },
    ],
  },
  {
    id: 'a03',
    slug: 'backlit-silhouette-basics',
    title: '逆光轮廓照怎么拍出高级感：三个不用修图的技巧',
    category: 'beauty',
    categoryName: '颜值美照',
    author: '林知夏',
    date: '2026-08-29',
    readTime: '4 分钟',
    views: '9.6 万',
    excerpt:
      '逆光最容易拍成一片死黑或一片死白，但只要把测光点挪一挪，轮廓感立刻就出来了。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20backlit%20portrait%20setup%20with%20soft%20sun%20flare%20behind%20a%20translucent%20cream%20scrim%2C%20glowing%20rim%20light%20halo%2C%20dust%20particles%20in%20the%20air%2C%20minimal%20beige%20studio%2C%20editorial%20glamour%20aesthetic%2C%20no%20people&width=1200&height=900&seq=gossip-art-backlit-01&orientation=landscape',
    alt: '逆光下柔和光晕与悬浮尘埃构成的简约影棚画面',
    tags: ['逆光', '轮廓光', '直出'],
    related: ['morning-light-portrait-guide', 'stage-lighting-skin-tone', 'jewelry-matching-rules'],
    sections: [
      {
        paragraphs: [
          '逆光照片好看的核心只有一句话：让边缘亮起来，让主体留住细节。听起来简单，但真正操作时，大部分人会把测光点放在主体上，结果背景全白，轮廓也没了。',
        ],
      },
      {
        heading: '把测光交给背景',
        paragraphs: [
          '先对背景测光，让高光保持在不过曝的临界点，然后再到主体上补一点点光。欠曝的部分用手动提亮或者小反光板处理，轮廓光就会自然保留下来。',
          '如果现场没有反光板，可以让被摄者稍微侧一点身，用对面墙面的反射光作为补光。这种方式在很多走廊和后台照片里都能看到。',
        ],
      },
      {
        heading: '留一点空气感',
        paragraphs: [
          '逆光最迷人的部分其实是空气里的尘埃和雾气。拍摄前在光路中制造一点薄雾，或者选择有浮尘的午后，画面的层次感会立刻不一样。',
        ],
      },
    ],
  },
  {
    id: 'a04',
    slug: 'red-carpet-raw-shots',
    title: '红毯生图直出：为什么今年的走位比去年更聪明',
    category: 'redcarpet',
    categoryName: '生图红毯',
    author: '周砚舟',
    date: '2026-09-08',
    readTime: '7 分钟',
    views: '23.1 万',
    excerpt:
      '红毯上停留的每一秒都被镜头记录。今年的几组生图里，走位节奏明显经过设计，停留点和转身角度都变了。',
    image:
      'https://readdy.ai/api/search-image?query=Long%20empty%20crimson%20red%20carpet%20leading%20toward%20a%20lit%20doorway%2C%20golden%20wall%20sconces%2C%20polished%20marble%20columns%2C%20soft%20evening%20haze%2C%20warm%20gold%20and%20deep%20red%20palette%2C%20cinematic%20editorial%20event%20photography%2C%20no%20people&width=1400&height=1050&seq=gossip-art-redcarpet-raw-01&orientation=landscape',
    alt: '通往灯光入口的长红毯与壁灯柱廊，呈现红毯现场氛围',
    tags: ['红毯', '生图', '走位'],
    related: ['group-photo-layout', 'gown-colour-logic', 'awards-night-bts'],
    sections: [
      {
        paragraphs: [
          '红毯是少数几个"时间被压缩"的场合。媒体区的快门声只在几次停留中响起，谁在什么位置停下来，停留多久，几乎决定了当天所有生图的成败。',
          '翻看今年几场活动的直出图，能明显感觉到节奏的变化：不再有人一路快走到尽头，而是分段走，每个定点停两秒左右，给足对焦时间。',
        ],
      },
      {
        heading: '定点比速度更重要',
        paragraphs: [
          '过去常见的做法是边走边挥手，看起来很热闹，但拍出来往往模糊。今年的生图里，更多是走到标记点后先站稳，肩膀稍微转向主摄方向，再完成一个缓慢的转身。',
          '这个转身的角度也很有讲究。大约四十五度的侧身最显身形比例，同时能让礼服的侧缝线条完整露出。',
        ],
      },
      {
        heading: '生图时代，状态就是内容',
        paragraphs: [
          '直出图不再需要精修，观众看到的就是现场本身。所以妆发是否服帖、礼服是否需要整理、表情是否放松，都会被完整记录下来。这也是为什么后台准备时间越来越长。',
        ],
        quote: '红毯上最贵的不是礼服，是那两秒的从容。',
      },
    ],
  },
  {
    id: 'a05',
    slug: 'rainy-red-carpet-moments',
    title: '雨天红毯名场面对比：透明伞和高开叉谁更出片',
    category: 'redcarpet',
    categoryName: '生图红毯',
    author: '顾晚晴',
    date: '2026-09-02',
    readTime: '5 分钟',
    views: '16.2 万',
    excerpt:
      '一场不期而至的雨，把红毯变成了最考验临场反应的舞台。伞、裙摆和积水反光，三者谁抢了镜？',
    image:
      'https://readdy.ai/api/search-image?query=Rainy%20night%20red%20carpet%20scene%20with%20wet%20reflective%20pavement%2C%20warm%20golden%20street%20lamps%2C%20glossy%20crimson%20surface%20reflections%2C%20soft%20falling%20rain%2C%20cinematic%20moody%20editorial%20atmosphere%2C%20no%20people&width=1400&height=1050&seq=gossip-art-rainy-carpet-01&orientation=landscape',
    alt: '雨夜中被金色路灯照亮的湿滑红毯与倒影',
    tags: ['雨天', '红毯', '名场面'],
    related: ['red-carpet-raw-shots', 'group-photo-layout', 'jewelry-matching-rules'],
    sections: [
      {
        paragraphs: [
          '下雨的红毯从来不缺话题。地面反光把灯光拉长，画面天然多了一层镜像，只要站位对，随手一张都像海报。',
        ],
      },
      {
        heading: '透明伞是把双刃剑',
        paragraphs: [
          '透明伞不会遮挡妆发，但会在面部打出细碎的反光。逆着路灯拍摄时，伞面上的水珠会形成一圈漂亮的光斑，带来妆发之外的画面信息。',
          '相比之下，深色雨伞更稳妥，只把视觉重心留在礼服和神态上，适合走优雅路线。',
        ],
      },
      {
        heading: '注意裙摆与积水',
        paragraphs: [
          '深色礼服过水后颜色会更饱和，看起来更有质感；浅色礼服则容易留下明显水痕。有经验的做法是提前把裙摆提离地面一点，慢速通过积水段，既保护了礼服，也给了镜头足够的拍摄时间。',
        ],
      },
    ],
  },
  {
    id: 'a06',
    slug: 'awards-night-bts',
    title: '颁奖礼后台直击：候场区那五分钟发生了什么',
    category: 'redcarpet',
    categoryName: '生图红毯',
    author: '周砚舟',
    date: '2026-08-27',
    readTime: '6 分钟',
    views: '11.3 万',
    excerpt:
      '镜头之外的候场区，才是真正决定红毯状态的地方。补妆、对流程、互相打气，全部浓缩在五分钟里。',
    image:
      'https://readdy.ai/api/search-image?query=Backstage%20waiting%20area%20with%20a%20vanity%20mirror%20surrounded%20by%20warm%20bulbs%2C%20velvet%20stool%2C%20garment%20bags%20and%20gold%20jewelry%20tray%2C%20soft%20amber%20lighting%2C%20dark%20crimson%20walls%2C%20editorial%20no%20people%20scene&width=1400&height=1050&seq=gossip-art-backstage-01&orientation=landscape',
    alt: '暖色灯泡环绕的后台化妆镜与前排丝绒凳',
    tags: ['后台', '颁奖礼', '采访'],
    related: ['red-carpet-raw-shots', 'group-photo-layout', 'stage-lighting-skin-tone'],
    sections: [
      {
        paragraphs: [
          '后台的节奏比红毯本身快得多。造型师最后一次整理礼服，经纪人核对出场顺序，艺人则对着镜子快速调整表情和呼吸。',
        ],
      },
      {
        heading: '灯光就是最好的预演',
        paragraphs: [
          '候场区的镜子灯色温接近现场的暖白光，很多艺人会在这里先确认妆面在暖光下的状态。这一步做得好，红毯上的生图基本不会翻车。',
        ],
      },
      {
        heading: '群像前的短暂交流',
        paragraphs: [
          '同场次的几位艺人往往会在候场区碰面，几句低声的交流和一次简短的合影，常常成为当晚最容易传播的画面。真正的高光同框，很多时候都发生在正式走红毯之前。',
        ],
      },
    ],
  },
  {
    id: 'a07',
    slug: 'group-photo-layout',
    title: '双人同框怎么站最上镜：间距、身高与视线的关系',
    category: 'group',
    categoryName: '高光同框',
    author: '林知夏',
    date: '2026-09-07',
    readTime: '6 分钟',
    views: '19.8 万',
    excerpt:
      '同样是两个人并排站，有的照片看着舒服，有的总觉得哪里别扭。问题往往出在间距和重心上。',
    image:
      'https://readdy.ai/api/search-image?query=Two%20elegant%20empty%20gilded%20chairs%20side%20by%20side%20on%20a%20polished%20stage%2C%20warm%20amber%20spotlights%20from%20above%2C%20deep%20crimson%20velvet%20backdrop%2C%20symmetrical%20composed%20editorial%20shot%2C%20no%20people&width=1200&height=900&seq=gossip-art-group-pair-01&orientation=landscape',
    alt: '舞台中央并排摆放的两把鎏金座椅与顶部暖光',
    tags: ['同框', '构图', '站位'],
    related: ['red-carpet-raw-shots', 'awards-night-bts', 'group-three-person'],
    sections: [
      {
        paragraphs: [
          '同框照片好不好看，和颜值关系其实没想象中那么大。真正起作用的是三样东西：两个人之间的距离、彼此的视线方向，以及拿相机的人站在哪个高度。',
        ],
      },
      {
        heading: '间距太近反而显拘谨',
        paragraphs: [
          '很多人为了显得亲密会靠得很近，结果肩膀挤在一起，身形被压缩。经验值是两个肩膀之间留出大约一个拳头到半掌的距离，既自然又不会显得生分。',
        ],
      },
      {
        heading: '身高差用重心解决',
        paragraphs: [
          '身高差距明显时，让高的一方微微向低的一方倾斜重心，或者稍微侧身用近侧腿承重，能在视觉上拉近距离。避免让矮的一方刻意踮脚，那会让姿态变得僵硬。',
          '视线也很重要。两个人看向同一个方向，画面会更有整体感；如果一方看向镜头、一方看向对方，则会多一层互动叙事。',
        ],
        quote: '同框的默契不在脸上，在两个人之间那道刚好的缝隙。',
      },
    ],
  },
  {
    id: 'a08',
    slug: 'group-three-person',
    title: '三人同框的排位法则：中间位不一定是好位置',
    category: 'group',
    categoryName: '高光同框',
    author: '沈斯年',
    date: '2026-09-01',
    readTime: '5 分钟',
    views: '13.5 万',
    excerpt:
      '三人合影最容易出现的问题就是一排站开、毫无层次。其实只要微调错位，画面立刻立体起来。',
    image:
      'https://readdy.ai/api/search-image?query=Three%20warm%20spotlight%20pools%20arranged%20in%20a%20staggered%20pattern%20on%20a%20dark%20stage%20floor%2C%20deep%20crimson%20curtain%20background%2C%20golden%20light%20beams%20in%20soft%20haze%2C%20editorial%20theatrical%20composition%2C%20no%20people&width=1200&height=900&seq=gossip-art-group-three-01&orientation=landscape',
    alt: '深色舞台地面上三束错落排列的暖色聚光灯',
    tags: ['三人同框', '构图', '层次'],
    related: ['group-photo-layout', 'awards-night-bts', 'backstage-group-portrait'],
    sections: [
      {
        paragraphs: [
          '三人一排站开是本能，但也是最容易拍得平的做法。只要把中间的人往后挪半步，画面立刻就有了前后关系。',
        ],
      },
      {
        heading: '错位制造呼吸感',
        paragraphs: [
          '让中间的人稍微后退、两侧的人微微内旋肩膀，三个人的轮廓就不会重叠成一条直线，各自的礼服线条都能完整呈现。',
          '如果条件允许，让左右两人一个正面一个四十五度侧身，画面的节奏会更好，视觉上也不会显得呆板。',
        ],
      },
      {
        heading: '视线落点决定气质',
        paragraphs: [
          '三人同时看镜头，是正式感最强的方案；两人看镜头、一人看向远方，会更有故事感，这类照片在活动通稿里非常常见。',
        ],
      },
    ],
  },
  {
    id: 'a09',
    slug: 'backstage-group-portrait',
    title: '后台同框抓拍：没有摆拍，却比摆拍更耐看',
    category: 'group',
    categoryName: '高光同框',
    author: '顾晚晴',
    date: '2026-08-25',
    readTime: '4 分钟',
    views: '10.2 万',
    excerpt:
      '后台的抓拍没有构图时间，却常常诞生最真实的画面。为什么这些照片总会被反复转发？',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20candid%20backstage%20corridor%20with%20soft%20amber%20wall%20lights%2C%20dark%20crimson%20velvet%20curtains%2C%20glossy%20wooden%20floor%20reflections%2C%20soft%20haze%2C%20cinematic%20documentary%20editorial%20atmosphere%2C%20no%20people&width=1200&height=900&seq=gossip-art-backstage-group-01&orientation=landscape',
    alt: '暖色壁灯映照的后台走廊与深红丝绒帷幔',
    tags: ['抓拍', '后台', '真实感'],
    related: ['awards-night-bts', 'group-photo-layout', 'group-three-person'],
    sections: [
      {
        paragraphs: [
          '后台抓拍最大的魅力在于不可复制。光线杂、空间小、人物还在移动，所有条件都不理想，但那种松弛感恰恰是正式合影给不了的。',
        ],
      },
      {
        heading: '真实感从哪里来',
        paragraphs: [
          '一是表情。没有倒数，也就没有刻意的笑容。二是距离。抓拍通常更近，能看到一举一动的细节。三是环境，走廊、衣架、化妆台都在画面里，信息量自然更足。',
        ],
      },
      {
        heading: '拍好抓拍的耐心',
        paragraphs: [
          '抓拍不是乱按快门，而是提前选好站位和光线，然后等待。优秀的后台照片，往往是摄影师在原地等了十几分钟才等到的那一个瞬间。',
        ],
      },
    ],
  },
  {
    id: 'a10',
    slug: 'gown-colour-logic',
    title: '礼服配色逻辑：为什么深红和香槟色今年特别多',
    category: 'style',
    categoryName: '造型解析',
    author: '沈斯年',
    date: '2026-09-05',
    readTime: '6 分钟',
    views: '14.9 万',
    excerpt:
      '红毯礼服的色彩并非随心选择，它和现场灯光、背景色以及镜头表现密切相关。今年流行深红与香槟，其实是必然。',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20fabric%20swatches%20of%20deep%20crimson%20satin%20and%20champagne%20gold%20silk%20draped%20on%20a%20marble%20table%2C%20warm%20studio%20light%2C%20luxury%20fashion%20styling%20detail%2C%20rich%20warm%20tones%2C%20no%20people&width=1200&height=900&seq=gossip-art-gown-colour-01&orientation=landscape',
    alt: '大理石桌面上深红缎面与香槟金丝绸面料的对比',
    tags: ['配色', '礼服', '色彩'],
    related: ['jewelry-matching-rules', 'champagne-gown-styling', 'red-carpet-raw-shots'],
    sections: [
      {
        paragraphs: [
          '红毯背景通常是深色地毯加上暖白灯光，这个组合会吃掉一部分颜色的饱和度。所以礼服颜色必须在灯光下仍然保有辨识度。',
        ],
      },
      {
        heading: '深红：自带存在感',
        paragraphs: [
          '深红在暖光下不会发灰，反而更显浓郁，与金色道具、深色地毯都能形成稳定对比。它还有一个优势：无论生图还是精修，颜色表现都很一致。',
        ],
      },
      {
        heading: '香槟：安全但不是寡淡',
        paragraphs: [
          '香槟色的高明度让它在深色环境里非常突出，同时不会喧宾夺主，适合把视觉重心留在面部和珠宝上。搭配同色系的高跟鞋和手包，整体会更完整。',
        ],
        quote: '颜色的任务不是抢镜，而是把人送到镜头中央。',
      },
    ],
  },
  {
    id: 'a11',
    slug: 'champagne-gown-styling',
    title: '香槟色礼服怎么搭才不俗气：配饰与妆发的三个平衡点',
    category: 'style',
    categoryName: '造型解析',
    author: '林知夏',
    date: '2026-08-30',
    readTime: '5 分钟',
    views: '8.8 万',
    excerpt:
      '香槟色看似百搭，但搭配不当就容易显得单薄。关键在于配饰的重量、妆发的松紧和材质的光泽度。',
    image:
      'https://readdy.ai/api/search-image?query=Champagne%20golden%20silk%20evening%20gown%20with%20delicate%20jewelry%20and%20satin%20heels%20displayed%20on%20a%20cream%20pedestal%2C%20soft%20warm%20studio%20lighting%2C%20luxury%20fashion%20editorial%20detail%20shot%2C%20elegant%20minimal%20composition%2C%20no%20people&width=1200&height=900&seq=gossip-art-champagne-style-01&orientation=landscape',
    alt: '香槟金色丝绸礼服与精致珠宝陈列于米色展台',
    tags: ['香槟色', '配饰', '妆发'],
    related: ['gown-colour-logic', 'jewelry-matching-rules', 'group-photo-layout'],
    sections: [
      {
        paragraphs: [
          '香槟色的问题在于它介于金与米之间，稍不注意就会显得没有重点。解决办法是给它一个明确的对比对象。',
        ],
      },
      {
        heading: '配饰要有分量',
        paragraphs: [
          '既然是高明度礼服，配饰最好选择有体积感的金属耳饰或夸张一点的项链，形成视觉锚点。过于细小的款式淹没在裙色里，反而显得随意。',
        ],
      },
      {
        heading: '妆发保持利落',
        paragraphs: [
          '礼服已经足够柔和，妆发就不宜再堆叠。干净的盘发或低马尾配合自然的裸妆，能让整体气质更统一，也更上镜。',
        ],
      },
    ],
  },
  {
    id: 'a12',
    slug: 'jewelry-matching-rules',
    title: '珠宝与礼服的三条搭配法则，看懂就不容易翻车',
    category: 'style',
    categoryName: '造型解析',
    author: '周砚舟',
    date: '2026-08-22',
    readTime: '5 分钟',
    views: '7.6 万',
    excerpt:
      '项链、耳饰、手镯不必全都上，留白反而更显贵。这三条搭配法则，几乎适用于所有正式场合。',
    image:
      'https://readdy.ai/api/search-image?query=Gold%20and%20pearl%20jewelry%20arranged%20elegantly%20on%20a%20dark%20crimson%20velvet%20tray%2C%20warm%20amber%20lighting%2C%20soft%20shadows%2C%20luxury%20editorial%20still%20life%20detail%20photography%2C%20rich%20warm%20tones%2C%20no%20people&width=1200&height=900&seq=gossip-art-jewelry-rules-01&orientation=landscape',
    alt: '深红丝绒托盘上陈列的金饰与珍珠珠宝',
    tags: ['珠宝', '搭配', '留白'],
    related: ['gown-colour-logic', 'champagne-gown-styling', 'red-carpet-raw-shots'],
    sections: [
      {
        paragraphs: [
          '很多造型翻车不是因为珠宝不够贵，而是因为戴得太多。正式场合的搭配，本质是在做减法。',
        ],
      },
      {
        heading: '领口决定重点',
        paragraphs: [
          '深V或抹胸领口适合大体积项链，能填补胸前留白；高领或立领礼服则应该放弃项链，把重点放在耳饰上，避免堆叠。',
        ],
      },
      {
        heading: '金银不混搭，色温要统一',
        paragraphs: [
          '同一套造型里，金属色最好保持统一。暖色礼服配金色，冷色礼服配银色，混搭容易显得杂乱，尤其是在舞台暖光下。',
          '第三条法则是留白。手腕、耳垂、颈间保留一处空白，整体会更松弛，也更符合当下的审美。',
        ],
        quote: '戴得少一点，气场反而多一点。',
      },
    ],
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '诱惑吃瓜主要收录哪些内容？',
    answer:
      '我们专注颜值与视觉盛宴，内容包括颜值美照、生图红毯、高光同框与造型解析四大板块。所有内容围绕高清美图、红毯名场面和同框高光时刻展开，方便你按兴趣快速找到想看的部分。',
  },
  {
    question: '站内的图片是原图吗，会不会压缩得很厉害？',
    answer:
      '我们优先保证观赏质量，图集在保留细节的前提下做了合理的体积优化，兼顾加载速度和清晰度。你可以直接放大查看服装纹理、妆面细节和现场灯光效果。',
  },
  {
    question: '多久更新一次？内容来源是什么？',
    answer:
      '正常情况每天更新四十组左右的内容，重点活动期间会实时跟进。素材来自公开的官方发布、品牌资料与现场直出图片，我们只做整理与解读，不添加未经证实的说法。',
  },
  {
    question: '可以按分类或关键词找内容吗？',
    answer:
      '可以。顶部导航提供四大分类入口，站内搜索支持按标题和标签过滤。你也可以在文章底部找到相关推荐，顺着往下看就能发现更多同类内容。',
  },
  {
    question: '如果内容涉及版权或需要更正，怎么联系？',
    answer:
      '请通过"联系我们"页面提交说明，或直接发送邮件到我们的合作邮箱。我们会在收到后尽快核实并处理，涉及更正的内容会第一时间调整。',
  },
  {
    question: '订阅之后会收到什么？',
    answer:
      '订阅后会收到每周精选的红毯名场面与同框高光合集，包含图集链接和简短解读。我们不会频繁推送，也不会把你的邮箱用于其他用途。',
  },
];

export const testimonials = [
  {
    name: '苏一诺',
    role: '视觉内容编辑',
    text: '分类做得很清楚，想看红毯生图就直接进对应栏目，不用在一堆标题里翻。图集的质量也很稳定。',
  },
  {
    name: '陈屿',
    role: '时尚博主',
    text: '造型解析这块对我帮助很大，配色逻辑和珠宝搭配讲得挺细，很多以前凭感觉的判断现在有了依据。',
  },
  {
    name: '许知遥',
    role: '普通读者',
    text: '每天都会来刷一会儿高光同框，更新快，而且同一场活动的内容会归在一起，看得很过瘾。',
  },
];

export const primaryNav = [
  { label: '首页', path: '/' },
  { label: '全部图集', path: '/category/all' },
  { label: '颜值美照', path: '/category/beauty' },
  { label: '生图红毯', path: '/category/redcarpet' },
  { label: '高光同框', path: '/category/group' },
  { label: '造型解析', path: '/category/style' },
];

export const secondaryNav = [
  { label: '常见问题', path: '/faq' },
  { label: '关于我们', path: '/about' },
  { label: '联系我们', path: '/contact' },
];

export const getArticleBySlug = (slug: string) => articles.find((item) => item.slug === slug);

export const getCategoryBySlug = (slug: string) => categories.find((item) => item.slug === slug);

export const getArticlesByCategory = (slug: string) =>
  articles.filter((item) => item.category === slug);